import React, { memo, FC } from 'react';
import { CardMedia, Typography } from '@one-thd/sui-atomic-components';
import ILineItem from '../../../../models/line-item';
import { generateImageUrl } from '../../../../utils/general';
import { CustomImage } from '../../../shared/CustomImage';

interface SorisCancelLineItemsProps {
  lineItems: ILineItem[];
}

const CancelLineitemsView: FC<SorisCancelLineItemsProps> = memo(
  // eslint-disable-next-line react/prop-types
  ({ lineItems }) => (
    <>
      {/* eslint-disable-next-line react/prop-types */}
      {lineItems.map((item, index) => (
        <div data-testid="lineitems" key={index} className="sui-flex sui-mb-4">
          <div className="sui-mr-4 sui-mt-1">
            <div style={{ width: '70px', height: '70px' }}>
              <CardMedia
                component={() => (
                  <CustomImage
                    src={generateImageUrl(item) ?? ''}
                    alt={item?.description}
                    lazy
                  />
                )}
              />
            </div>
          </div>
          <div className="sui-flex sui-flex-col">
            <Typography>
              <span className="sui-font-bold sui-pr-1">
                {item.brandName?.toUpperCase()}
              </span>
              <span>{item.description ? item.description : ''}</span>
            </Typography>
            <div className="sui-mt-2 ">
              <Typography>Qty: {item.currentQuantity}</Typography>
            </div>
          </div>
        </div>
      ))}
    </>
  ),
);

export default CancelLineitemsView;
